module.exports = __webpack_public_path__ + "img/MENU_COM_ICONES.d9d13cb1.png";